import { atom } from "jotai";
import { CarListItemModel } from "../models/CarsModels";

export const selectedCarAtom = atom<CarListItemModel | undefined>(undefined);